import { isEmpty, isExist } from "cxa-utils";

const requiredText = "Required";
const yesValue = "Yes";

const validateRequired = value => !value && requiredText;

const validateRequiredForSpouse = (values, errors) => {
  if (values.SpouseName) {
    if (!values.SpouseHeight) {
      errors.SpouseHeight = requiredText;
    }
    if (!values.SpouseWeight) {
      errors.SpouseWeight = requiredText;
    }
  }
};

const validateRequiredForChild = (values, errors) => child => {
  if (isEmpty(values[`${child}ChildHeight`])) {
    errors[`${child}ChildHeight`] = requiredText;
  }

  if (isEmpty(values[`${child}ChildWeight`])) {
    errors[`${child}ChildWeight`] = requiredText;
  }
};

const validateRequiredForHabits = (values, errors, member) => {
  const prefix = member !== "Emp" ? "Emp" : "";

  if (values[`${member}Smoke`] === yesValue && !values[`${member}SmokeQuantity`]) {
    errors[`${member}SmokeQuantity`] = requiredText;
  }
  if (values[`${member}Smoke`] === yesValue && !values[`${member}SmokeNoOfYears`]) {
    errors[`${member}SmokeNoOfYears`] = requiredText;
  }

  if (values[`${member}${prefix}ConsumeAlcohol`] === yesValue && !values[`${member}AlcoholType`]) {
    errors[`${member}AlcoholType`] = requiredText;
  }

  if (
    values[`${member}${prefix}ConsumeAlcohol`] === yesValue &&
    !values[`${member}AlcoholQuantity`]
  ) {
    errors[`${member}AlcoholQuantity`] = requiredText;
  }

  if (values[`${member}Adventure`] === yesValue && !values[`${member}AdventureInfo`]) {
    errors[`${member}AdventureInfo`] = requiredText;
  }
};

const validateRequiredForFamilyHistory = (values, errors) => {
  if (values.EmpFamilyHistory === yesValue) {
    if (!values.FamilyRelationship1) {
      errors.FamilyRelationship1 = requiredText;
    }
  }
};

const validateFemaleEmpQuestions = (values, errors) => {
  if (values.Gender === "Female") {
    if (!values.EmpBreastDisorder) {
      errors.EmpBreastDisorder = requiredText;
    }

    if (!values.EmpMenstruationDisorder) {
      errors.EmpMenstruationDisorder = requiredText;
    }

    if (!values.EmpPapSmearDisorder) {
      errors.EmpPapSmearDisorder = requiredText;
    }

    if (!values.EmpGynaecologicalDisorder) {
      errors.EmpGynaecologicalDisorder = requiredText;
    }

    if (!values.EmpPregnant) {
      errors.EmpPregnant = requiredText;
    }

    if (!values.EmpPregnantComplication) {
      errors.EmpPregnantComplication = requiredText;
    }
  }
};

const validateForm = values => {
  const errors = {};
  const children = [
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Sixth",
    "Seventh",
    "Eighth",
    "Ninth",
    "Tenth",
  ];

  if (isExist(values)) {
    const _validateRequiredForChild = validateRequiredForChild(values, errors);

    validateRequiredForSpouse(values, errors);
    validateRequiredForHabits(values, errors, "Emp");
    validateRequiredForHabits(values, errors, "Sp");
    validateRequiredForHabits(values, errors, "Ch");
    validateRequiredForFamilyHistory(values, errors);
    validateFemaleEmpQuestions(values, errors);

    children.forEach(child => {
      if (isExist(values[`${child}ChildName`])) {
        _validateRequiredForChild(child);
      }
    });
  }

  // if (values.EmpSmoke === "Yes" && !values.EmpSmokeQuantity) {
  //   errors.EmpSmokeQuantity = "Required";
  // }
  // if (values.EmpSmoke === "Yes" && !values.EmpSmokeNoOfYears) {
  //   errors.EmpSmokeNoOfYears = "Required";
  // }

  // if (values.EmpConsumeAlcohol === "Yes" && !values.EmpAlcoholType) {
  //   errors.EmpAlcoholType = "Required";
  // }

  // if (values.EmpConsumeAlcohol === "Yes" && !values.EmpAlcoholQuantity) {
  //   errors.EmpAlcoholQuantity = "Required";
  // }

  // if (values.EmpAdventure === "Yes" && !values.EmpAdventureInfo) {
  //   errors.EmpAdventureInfo = "Required";
  // }
  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Ge/validation.js